import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

// Protects admin routes. Renders nothing if the user is not yet authenticated
// (LoginProvider handles showing the login screen). Redirects to /home if the
// user is authenticated but not a superuser.
export default function RequireAdmin() {
    const user = useSelector((state) => state.user)

    if (!user._id) return null
    if (!user.isSuperuser) return <Navigate replace to="/home" />
    return <Outlet />
}
